import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { ButtonModule } from "@bfx/primeng/button";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TabViewModule } from "@bfx/primeng/tabview";

import { BfxInterventionBlotterComponent } from "./bfx-intervention-blotter.component";
import { BfxInterventionContextMenuComponent } from "./bfx-intervention-contextmenu.component";
import { ManualPricingContainerComponent } from "./manual-pricing/manual-pricing-container.component";

import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxInterventionBlotterService } from "./services/bfx-intervention-blotter.service";
import { BfxInterventionActionsService } from "./services/bfx-intervention-actions.service";
import { BfxInterventionContextMenuService } from "./services/bfx-intervention-contextmenu.service";
import { ManualPricingManagerService } from "./manual-pricing/services/manual-pricing-manager.service";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";

import { BfxBlotterInterventionFilterService } from "./services/bfx-blotter-intervention-filter.service";
import { BfxMenusModule } from "app/bfx-menus/bfx-menus.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { DITooltip } from "./renderers/DITooltip";
import { FwdRollPricingService } from "app/bfx-blotter-intervention/fwd-roll-pricing/services/fwd-roll-pricing.service";
import { FwdRollPricingComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/fwd-roll-pricing.component";
import { BfxFwdRollOrdersBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-orders-blotter";
import { BfxFwdRollCurrenciesBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-currencies-blotter";
import { BfxFwdRollDealtPairsBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-dealt-pairs-blotter";
import { SplitterModule } from "@bfx/primeng/splitter";
import { FwdRollMarketPtsEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollMarketPtsEditor";
import { FwdRollBaseEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollBaseEditor";
import { FwdRollClientPtsEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollClientPtsEditor";
import { FwdRollFwdMarkupEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollFwdMarkupEditor";
import { FwdRollIntentRenderer } from "app/bfx-blotter-intervention/fwd-roll-pricing/renderers/FwdRollIntentRenderer";
import { LockRowRenderer } from "app/bfx-blotter-intervention/fwd-roll-pricing/renderers/LockRowRenderer";
import { FlexLayoutModule } from "@angular/flex-layout";
import { OrderStatusRenderer } from "app/bfx-blotter-intervention/fwd-roll-pricing/renderers/OrderStatusRenderer";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";

@NgModule({
  declarations: [
    BfxInterventionBlotterComponent,
    BfxInterventionContextMenuComponent,
    ManualPricingContainerComponent,
    DITooltip,
    BfxFwdRollOrdersBlotterComponent,
    BfxFwdRollCurrenciesBlotterComponent,
    BfxFwdRollDealtPairsBlotterComponent,
    FwdRollPricingComponent,
    FwdRollBaseEditor,
    FwdRollMarketPtsEditor,
    FwdRollClientPtsEditor,
    FwdRollFwdMarkupEditor,
    LockRowRenderer,
    OrderStatusRenderer,
    FwdRollIntentRenderer,
  ],
  imports: [
    FlexLayoutModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    AutoCompleteModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    TabViewModule,
    AgGridModule.withComponents([
      DITooltip,
      FwdRollMarketPtsEditor,
      FwdRollClientPtsEditor,
      FwdRollFwdMarkupEditor,
      LockRowRenderer,
      OrderStatusRenderer,
      FwdRollIntentRenderer,
      CommonIntentRenderer,
    ]),
    BfxSharedModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BfxElementsLibraryModule,
    BaseComponentsModule,
    SplitterModule,
  ],
  providers: [
    BfxInterventionBlotterService,
    BfxInterventionActionsService,
    BfxInterventionContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxBlotterInterventionFilterService,
    ManualPricingManagerService,
    FwdRollPricingService,
  ],
  exports: [ManualPricingContainerComponent],
  bootstrap: [BfxInterventionBlotterComponent],
})
export class BfxInterventionBlotterModule {}
